import {Injectable} from '@angular/core';
import {AbstractDeleteOneService} from '../../../../../core/service/v2/service/delete/abstractDeleteOne.service';
import {MedicalRecordSportModel} from '../../api/model/medicalRecordSport.model';
import {MedicalSportRepository} from './ngrx/medicalSport.repository';
import {MedicalSportDataServiceAdapter} from './ngrx/medicalSportDataService.adapter';

@Injectable()
export class MedicalSportDeleteService extends
    AbstractDeleteOneService<MedicalRecordSportModel, MedicalRecordSportModel> {

    constructor(public repository: MedicalSportRepository,
                public dataServiceAdapter: MedicalSportDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
